<template>
  <c-text as="span" white-space="nowrap">
    <c-text
      as="span"
      display="inline-block"
      width="3"
      height="3"
      mr="xs"
      border-radius="full"
      :background="
        (availability === 'CHECK_AVAILABILITY' && 'brand.grayDark') ||
        (availability === 'NOT_AVAILABLE' && 'brand.grayDark') ||
        (availability === 'AVAILABLE' && 'brand.green') ||
        (availability === 'AVAILABLE_ON_DATE' && 'brand.orange') ||
        // out of stock
        'brand.red'
      "
      v-chakra="{
        '@media print': {
          display: 'none !important',
        },
      }"
    />

    <c-text v-if="availability === 'CHECK_AVAILABILITY'" as="span">
      {{ $t("shoppingCart.checkAvailability") }}
    </c-text>

    <c-text v-else-if="availability === 'NOT_AVAILABLE'" as="span">
      {{ $t("availability.NOT_AVAILABLE") }}
    </c-text>

    <c-text v-else-if="availability === 'AVAILABLE'" as="span">
      {{ $t("availability.AVAILABLE") }}
    </c-text>

    <c-text v-else-if="availability === 'AVAILABLE_ON_DATE'" as="span">
      {{ $t("availability.AVAILABLE") }} ({{ availabilityDate }})
    </c-text>

    <c-text v-else as="span">
      {{ $t("availability.OUT_OF_STOCK") }}
    </c-text>
  </c-text>
</template>

<script lang="ts">
import { CText } from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "AvailabilityInfo",
  components: {
    CText,
  },
  props: {
    availability: {
      type: String,
      required: true,
    },
    availabilityDate: {
      type: String,
      default: "",
    },
  },
});
</script>
